module.exports = __webpack_public_path__ + "static/koledata-e-vyzmojna-7b55e11ad917310c024084dcfe6c2420.png";